import React from 'react';
import PropTypes from 'prop-types';
import CookiesNotice from '../Cookies/CookiesNotice';
import Richtext from '../Richtext/Richtext';

const Footer = (props) => {
  const { mode, settings } = props;

  return (
    <>
      <footer className="w-100 pt-5 pb-5 bg-dark text-light font-small">
        <div className="container-fluid">
          <div className="row">
            <div className="col text-center">
              <Richtext content={settings.footer} mode="simple" />
            </div>
          </div>
        </div>
      </footer>
      <CookiesNotice mode={mode} message={settings.cookies} />
    </>
  );
};

export default Footer;

Footer.propTypes = {
  settings: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mode: PropTypes.string,
};

Footer.defaultProps = {
  settings: null,
  mode: 'normal',
};
